import { useState } from 'react'
import { Button, message } from 'antd'
import Customupload from '../../../../components/UploadFile'
import { RcFile } from 'antd/lib/upload'
interface Props {
  onUploadfile?: (e?: RcFile) => void // 开始上传
}
// 存量物料导入
const Preexport = (props: Props) => {
  const { onUploadfile } = props
  const [fileData, setfileData] = useState<RcFile>()

  function onUploadfileData(file: RcFile) {
    const reg = new RegExp(/^.*(\.xlsx|\.xls)$/)
    const index = file.name.search(reg)
    if (index === -1) {
      message.warning('请上传正确的文件格式！')
      return false
    }
    setfileData(file)
    return false
  }

  function onClickUpload() {
    if (onUploadfile) {
      onUploadfile(fileData)
    }
  }

  return (
    <div>
      <Customupload
        textBtn="选择文件"
        visibleFile={false}
        style={{ margin: '0 10px 10px 0' }}
        accept={'.xls,.xlsx'}
        beforeUpload={onUploadfileData}
      />
      <br />
      {fileData ? fileData.name : null}
      {fileData ? (
        <Button
          type="primary"
          onClick={onClickUpload}
          style={{ margin: '0 0 10px 10px' }}
        >
          开始上传
        </Button>
      ) : null}
    </div>
  )
}

export default Preexport
import { useState } from 'react'
import { Button, message } from 'antd'
import Customupload from '../../../../components/UploadFile'
import { RcFile } from 'antd/lib/upload'
interface Props {
  onUploadfile?: (e?: RcFile) => void // 开始上传
}
// 存量物料导入
const Preexport = (props: Props) => {
  const { onUploadfile } = props
  const [fileData, setfileData] = useState<RcFile>()

  function onUploadfileData(file: RcFile) {
    const reg = new RegExp(/^.*(\.xlsx|\.xls)$/)
    const index = file.name.search(reg)
    if (index === -1) {
      message.warning('请上传正确的文件格式！')
      return false
    }
    setfileData(file)
    return false
  }

  function onClickUpload() {
    if (onUploadfile) {
      onUploadfile(fileData)
    }
  }

  return (
    <div>
      <Customupload
        textBtn="选择文件"
        visibleFile={false}
        style={{ margin: '0 10px 10px 0' }}
        accept={'.xls,.xlsx'}
        beforeUpload={onUploadfileData}
      />
      <br />
      {fileData ? fileData.name : null}
      {fileData ? (
        <Button
          type="primary"
          onClick={onClickUpload}
          style={{ margin: '0 0 10px 10px' }}
        >
          开始上传
        </Button>
      ) : null}
    </div>
  )
}

export default Preexport
